import { CustomValidatorArgs } from '../types/CSVTypes';


const customerOrderNumberValidator = ({ value }: CustomValidatorArgs) => {
  const customerOrderNumber = String(value);
  if (customerOrderNumber?.length > 255) {
    return 'invalidCustomerOrderNumber';
  }
  return null;
};

export default customerOrderNumberValidator;
